<template>
  <v-main class="layout-empty">
    <slot />
  </v-main>
</template>

<script>
export default {
  name: 'LayoutEmpty',
};
</script>
